export default __webpack_public_path__ + "static/media/activitytab-watchlist.89d59f8b.svg";